/* global axios */
import ApiClient from './ApiClient';

export class InternalChatAPI extends ApiClient {
  constructor() {
    super('internal_conversations', { accountScoped: true });
  }

  update(id, data) {
    if (data instanceof FormData) {
      return axios.patch(`${this.url}/${id}`, data, {
        headers: { 'Content-Type': 'multipart/form-data' },
      });
    }
    return super.update(id, data);
  }

  getMessages({ conversationId, page = 1 }) {
    return axios.get(`${this.url}/${conversationId}/messages`, {
      params: { page },
    });
  }

  sendMessage({ conversationId, payload }) {
    if (payload instanceof FormData) {
      return axios.post(`${this.url}/${conversationId}/messages`, payload, {
        headers: { 'Content-Type': 'multipart/form-data' },
      });
    }
    return axios.post(`${this.url}/${conversationId}/messages`, payload);
  }

  deleteMessage({ conversationId, messageId }) {
    return axios.delete(`${this.url}/${conversationId}/messages/${messageId}`);
  }

  addParticipants({ conversationId, userIds, role = 'member' }) {
    return axios.post(`${this.url}/${conversationId}/participants`, {
      user_ids: userIds,
      role,
    });
  }

  removeParticipant({ conversationId, userId }) {
    return axios.delete(`${this.url}/${conversationId}/participants/${userId}`);
  }

  updateParticipantRole({ conversationId, userId, role }) {
    return axios.patch(`${this.url}/${conversationId}/participants/${userId}`, {
      role,
    });
  }

  markAsRead({ conversationId }) {
    return axios.post(`${this.url}/${conversationId}/mark_read`);
  }

  markAsUnread({ conversationId }) {
    return axios.post(`${this.url}/${conversationId}/mark_unread`);
  }

  supervise({ userId }) {
    return axios.get(`${this.url}/supervise`, {
      params: { user_id: userId },
    });
  }
}

export default new InternalChatAPI();
